// @flow
import { List, ListItem, ListItemIcon, ListItemSecondaryAction, ListItemText } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import {
  Build as DraftIcon,
  Create as EditIcon,
  HourglassEmpty as ValidatingIcon,
  Visibility as ShowIcon,
  Work as ProcessingIcon
} from '@material-ui/icons';
import React, { useContext } from 'react';
import { useTranslation } from 'react-i18next';
import SignProcess from '../model/SignProcess';
import { formatDate } from '../util/date';
import { toSentence } from '../util/string';
import { AuthContext } from '../context/auth';

const useStyles = makeStyles((theme) => ({
  list: {
    width: '100%',
    backgroundColor: theme.palette.background.paper,
  },
  draft: {
    color: theme.palette.secondary[ '900' ],
  },
  validating: {
    color: theme.palette.grey[ '700' ],
  },
  processing: {
    color: theme.palette.primary[ '700' ],
  },
}));

type Props = {
  list: SignProcess[],
  onAction: (SignProcess) => void,
};

const ProcessesList = (props: Props) => {
  const { user } = useContext(AuthContext);
  const { t } = useTranslation();
  const { list, onAction } = props;
  const classes = useStyles();

  if (!list || list.length === 0) {
    return <></>;
  }

  return (
    <List component="nav" aria-label="processes list" className={classes.list}>
      {list.map((item) => {
        let itemClass = classes.draft;
        if (item.isProcessing()) {
          itemClass = classes.processing;
        } else if (item.hasVideoLoaded()) {
          itemClass = classes.validating;
        }
        const primary = (
          <>
            <span>{(!!user && user.isRetail) && (item.name || item.code) + ' - '}</span>
            {t(toSentence(item.processType))}&nbsp;
            <small> ({t(`Your process is ${item.state}`)})</small>
          </>
        );
        let secondary = `${t('Created')}: ${formatDate(item.dateTime)}.`;
        secondary += `  ${t('Duration')}: ${item.durationValue()} ${t(item.durationLabel()).toLowerCase()}.`;
        if (!!item.containerTitle) {
          secondary += `  ${t('Container')}: ${item.containerTitle} ($${item.containerPrice.toFixed(2)}).`;
        }
        secondary += `  ${t('Total price')}: $${item.price.toFixed(2)}.`;
        return (
          <ListItem button key={item.code} onClick={() => {
            onAction(item);
          }}>
            <ListItemIcon>
              {!item.hasVideoLoaded()
                && <DraftIcon className={classes.draft}/>}
              {(item.hasVideoLoaded() && !item.isProcessing() && !item.isCompleted())
                && <ValidatingIcon className={classes.draft}/>}
              {(item.isProcessing() || item.isCompleted())
                && <ProcessingIcon className={classes.processing}/>}
            </ListItemIcon>
            <ListItemText
              className={itemClass}
              primary={primary}
              secondary={secondary}/>
            <ListItemSecondaryAction>
              {!item.hasVideoLoaded()
                && <EditIcon className={classes.draft}/>}
              {(item.hasVideoLoaded() && !item.isProcessing() && !item.isCompleted())
                && <ShowIcon className={classes.validating}/>}
              {(item.isProcessing() || item.isCompleted())
                && <ShowIcon className={classes.processing}/>}
            </ListItemSecondaryAction>
          </ListItem>
        );
      })}
    </List>
  );
};

export default ProcessesList;
